import { push } from "react-router-redux";
import { startSubmit, stopSubmit } from "redux-form";
import _ from "lodash";

import api from "../services/api";
// import { showError } from "./common.actions";

export const LOGIN_FORM = "LogIn";

export function login(credentials) {
  return dispatch => {
    dispatch(startSubmit(LOGIN_FORM));

    api
      .login(credentials)
      .then(response => {
        const { data } = response.data;
        const role = _.get(data, "roles[0].name");
        const status = _.get(data, "status.name");
        const redirectUrlAfterLogin = localStorage.getItem(
          "redirectUrlAfterLogin"
        );
        const redirectRoleAfterLogin = localStorage.getItem(
          "redirectRoleAfterLogin"
        );
        const memberLandingPages = {
          "account-created": "/member/complete-profile",
          active: "/member/projects/matches",
          applied: "/member/confirmation",
          approved: "/member/projects/matches",
          "pending-interview": "/member/confirmation",
          "waiting-for-references": "/member/confirmation"
        };
        const projectsNumber = _.get(data, "stats.projects.total");

        let nextUrl = "";

        if (redirectUrlAfterLogin && redirectRoleAfterLogin === role) {
          nextUrl = redirectUrlAfterLogin;
        } else if (role === "member") {
          nextUrl = memberLandingPages[status];
        } else if (role === "employer") {
          nextUrl =
            projectsNumber && projectsNumber > 0
              ? "/company/projects"
              : "/company/home";
        } else if (role === "admin") {
          nextUrl = "/admin/dashboard";
        }

        localStorage.clear();
        localStorage.setItem("token", data.token);
        localStorage.setItem("verified", data.verified);
        localStorage.setItem("User:Id", data.id);
        localStorage.setItem("userEmail", data.email);
        localStorage.setItem("role", data.roles[0].name);
        localStorage.setItem("userName", data.first_name);
        localStorage.setItem(
          "companyName",
          _.get(data, "profile.company.name")
        );
        localStorage.setItem("status", status);

        /* old members redirection */
        if (_.get(data, "profile.profile_pending")) {
          nextUrl = "/member/profile";
          localStorage.setItem("isOldMember", true);
        }

        dispatch(push(nextUrl));
      })
      .catch(error => {
        if (error.response) {
          // let errorCode = error.response.data.status_id;
          let errorMessage = error.response.data.message;
          let validationErrors = error.response.data.errors
            ? error.response.data.errors
            : {};

          // Handle error and message
          if (validationErrors) {
            if (validationErrors.email) {
              if (errorMessage) {
                validationErrors.password = validationErrors.email;
                delete validationErrors.email;
              } else {
                delete validationErrors.password;
              }
            }

            dispatch(stopSubmit(LOGIN_FORM, validationErrors));
          }
        }
      });
  };
}

export function logout() {
  return dispatch => {
    api
      .logout()
      .then(() => {
        localStorage.clear();
        dispatch(push("/log-in"));
      })
      .catch(() => {
        localStorage.clear();
        dispatch(push("/log-in"));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/auth.actions.js